/* eslint-disable no-case-declarations */
type Action<K, V = void> = V extends void ? { type: K } : { type: K } & V;

export type ApproversResponse = {
  value: string;
  label: string;
};

export type ApproversStateType = {
  levels: Array<Array<ApproversResponse>>;
};

export const initialState = {
  levels: [],
};

export const init = (initialArg, setTouched): ApproversStateType => {
  initialArg.forEach((_, index) => {
    setTouched((prevState) => {
      return {
        ...prevState,
        [`level_${index + 1}`]: true,
      };
    });
  });

  return { levels: initialArg };
};

export const approversReducer = (
  state: ApproversStateType,
  action: Action<
    | "ADD_SELECTED_OPTIONS"
    | "UPDATE_SELECTED_OPTIONS"
    | "ADD_LEVEL"
    | "REMOVE_LEVEL"
    | "CLEAR_LEVELS",
    { index?: number; payload?: Array<ApproversResponse> }
  >
): ApproversStateType => {
  switch (action.type) {
    case "ADD_SELECTED_OPTIONS":
      const addState = {
        ...state,
        levels: [
          ...state.levels.slice(0, action.index),
          action.payload,
          ...state.levels.slice(action.index),
        ],
      };

      return addState;

    case "UPDATE_SELECTED_OPTIONS":
      const updateLevels = state.levels.map((item, index) => {
        if (index !== action.index) {
          return item;
        }

        return action.payload;
      });
      const updateState = {
        ...state,
        levels: updateLevels,
      };
      return updateState;
    case "ADD_LEVEL":
      const addLevelState = {
        ...state,
        levels: [...state.levels.slice(), []],
      };
      return addLevelState;
    case "REMOVE_LEVEL":
      const removeLevelState = {
        ...state,
        levels: [
          ...state.levels.filter((_, index) => {
            return index !== action.index;
          }),
        ],
      };
      return removeLevelState;
    case "CLEAR_LEVELS":
      return initialState;
    default:
      throw new Error();
  }
};

export type ErrorsResponse = {
  name?: Array<string>;
};

export type ErrorsStateType = {
  errors: ErrorsResponse;
};

export const errorsInitialState = {
  errors: {},
};

export const errorsInit = (): ErrorsStateType => {
  return errorsInitialState;
};

export const errorsReducer = (
  state: ErrorsStateType,
  action: Action<
    "ADD_ERROR" | "REMOVE_ERROR",
    { name?: string; payload?: string }
  >
): ErrorsStateType => {
  switch (action.type) {
    case "ADD_ERROR":
      const addIndex = state.errors[action.name].indexOf(action.payload) || 0;

      const addState = {
        ...state,
        errors: {
          ...state.errors,
          [action.name]: [
            ...state.errors[action.name].slice(0, addIndex),
            action.payload,
            ...state.errors[action.name].slice(addIndex),
          ],
        },
      };
      return addState;

    case "REMOVE_ERROR":
      const removeIndex =
        state.errors[action.name] && action.payload
          ? state.errors[action.name].indexOf(action.payload)
          : -1;

      const newArray =
        state.errors[action.name] && action.payload
          ? state.errors[action.name].slice()
          : [];
      newArray.splice(removeIndex, 1);

      const removeState = {
        ...state,
        errors: {
          ...state.errors,
          [action.name]: newArray,
        },
      };

      return removeState;

    default:
      throw new Error();
  }
};
